"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsPayProvidersListCtl = /** @class */ (function (_super) {
    __extends(BrandsPayProvidersListCtl, _super);
    function BrandsPayProvidersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_provider_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.provider_identity; });
        _this.dk_provider_name = UIUtils_1.UIUtils.IProp2Str(function (o) { o.provider_name; });
        _this.dk_provider_system = UIUtils_1.UIUtils.IProp2Str(function (o) { o.provider_system; });
        _this.dk_provider_logo = UIUtils_1.UIUtils.IProp2Str(function (o) { o.provider_logo; });
        _this.dk_time_to_expire = UIUtils_1.UIUtils.IProp2Str(function (o) { o.time_to_expire; });
        _this.dk_min_deposit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_deposit_amount; });
        _this.dk_max_deposit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_deposit_amount; });
        _this.dk_is_check_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_check_url; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this.dk_is_trusted_only = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_trusted_only; });
        _this.dk_is_mobile = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_mobile; });
        _this.dk_is_desktop = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_desktop; });
        _this.dk_trust_zone_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trust_zone_code; });
        _this.dk_trust_zone_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.trust_zone_title; });
        _this.dk_is_custom_trusted_amounts = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_custom_trusted_amounts; });
        _this.dk_min_deposit_amount_trusted = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_deposit_amount_trusted; });
        _this.dk_max_deposit_amount_trusted = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_deposit_amount_trusted; });
        _this.dk_min_dep_amount_to_handle_as_trusted = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_dep_amount_to_handle_as_trusted; });
        _this.dk_is_trusted_by_custom_deposit_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_trusted_by_custom_deposit_count; });
        _this.dk_min_deposit_count_to_be_trusted = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_deposit_count_to_be_trusted; });
        _this.dk_is_trusted_by_custom_withdraw_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_trusted_by_custom_withdraw_count; });
        _this.dk_min_withdraw_count_to_be_trusted = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_withdraw_count_to_be_trusted; });
        _this.dk_is_randomize_per_day_amount_by_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_randomize_per_day_amount_by_percent; });
        _this.dk_min_dep_amount_limit_randomize_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_dep_amount_limit_randomize_percent; });
        _this.dk_max_dep_amount_limit_randomize_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_dep_amount_limit_randomize_percent; });
        _this.dk_randomized_min_dep_amount_per_day_limit = UIUtils_1.UIUtils.IProp2Str(function (o) { o.randomized_min_dep_amount_per_day_limit; });
        _this.dk_date_limit_randomized = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_limit_randomized; });
        /*
        
            description: string;
            
        is_use_min_dep_amount_per_day_limit: boolean;
        min_dep_amount_per_day_limit: number;
        
        is_mark_suspicious_withdraw_on_treshold_dep_amount: boolean;
        treshold_dep_amount_to_mark_suspicious: number;
        
        */
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_use_min_dep_amount_per_day_limit = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_use_min_dep_amount_per_day_limit; });
        _this.dk_min_dep_amount_per_day_limit = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_dep_amount_per_day_limit; });
        _this.dk_is_mark_suspicious_withdraw_on_treshold_dep_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_mark_suspicious_withdraw_on_treshold_dep_amount; });
        _this.dk_treshold_dep_amount_to_mark_suspicious = UIUtils_1.UIUtils.IProp2Str(function (o) { o.treshold_dep_amount_to_mark_suspicious; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsPayProvidersListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandsPayProvidersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsPayProvidersListCtl.prototype.LoadData = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListBrandPayProvidersByBrandIdGet.exec({
            brand_id: brandId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    provider_identity: resp.list[i].provider_identity,
                    provider_name: resp.list[i].provider_name,
                    provider_system: resp.list[i].provider_system,
                    provider_logo: resp.list[i].provider_logo,
                    time_to_expire: resp.list[i].time_to_expire,
                    min_deposit_amount: resp.list[i].min_deposit_amount,
                    max_deposit_amount: resp.list[i].max_deposit_amount,
                    is_check_url: resp.list[i].is_check_url,
                    order_number: resp.list[i].order_number,
                    is_trusted_only: resp.list[i].is_trusted_only,
                    is_mobile: resp.list[i].is_mobile,
                    is_desktop: resp.list[i].is_desktop,
                    is_locked: resp.list[i].is_locked,
                    trust_zone_code: resp.list[i].trust_zone_code,
                    trust_zone_title: resp.list[i].trust_zone_title,
                    is_custom_trusted_amounts: resp.list[i].is_custom_trusted_amounts,
                    min_deposit_amount_trusted: resp.list[i].min_deposit_amount_trusted,
                    max_deposit_amount_trusted: resp.list[i].max_deposit_amount_trusted,
                    min_dep_amount_to_handle_as_trusted: resp.list[i].min_dep_amount_to_handle_as_trusted,
                    is_trusted_by_custom_deposit_count: resp.list[i].is_trusted_by_custom_deposit_count,
                    min_deposit_count_to_be_trusted: resp.list[i].min_deposit_count_to_be_trusted,
                    is_trusted_by_custom_withdraw_count: resp.list[i].is_trusted_by_custom_withdraw_count,
                    min_withdraw_count_to_be_trusted: resp.list[i].min_withdraw_count_to_be_trusted,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    is_use_min_dep_amount_per_day_limit: resp.list[i].is_use_min_dep_amount_per_day_limit,
                    min_dep_amount_per_day_limit: resp.list[i].min_dep_amount_per_day_limit,
                    is_mark_suspicious_withdraw_on_treshold_dep_amount: resp.list[i].is_mark_suspicious_withdraw_on_treshold_dep_amount,
                    treshold_dep_amount_to_mark_suspicious: resp.list[i].treshold_dep_amount_to_mark_suspicious,
                    is_randomize_per_day_amount_by_percent: resp.list[i].is_randomize_per_day_amount_by_percent,
                    min_dep_amount_limit_randomize_percent: resp.list[i].min_dep_amount_limit_randomize_percent,
                    max_dep_amount_limit_randomize_percent: resp.list[i].max_dep_amount_limit_randomize_percent,
                    randomized_min_dep_amount_per_day_limit: resp.list[i].randomized_min_dep_amount_per_day_limit,
                    date_limit_randomized: moment(resp.list[i].date_limit_randomized_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayProvidersListCtl.prototype.LoadDataByZone = function (AllTrustZones, TrustZonesIdList, brandId, onDone) {
        var _this = this;
        webAApi_1.ListBrandPayProvidsByBrandAndTrustZoneGet.exec({
            brand_id: brandId,
            all_trust_zones: AllTrustZones,
            trust_zone_id_list: TrustZonesIdList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    provider_identity: resp.list[i].provider_identity,
                    provider_name: resp.list[i].provider_name,
                    provider_system: resp.list[i].provider_system,
                    provider_logo: resp.list[i].provider_logo,
                    time_to_expire: resp.list[i].time_to_expire,
                    min_deposit_amount: resp.list[i].min_deposit_amount,
                    max_deposit_amount: resp.list[i].max_deposit_amount,
                    is_check_url: resp.list[i].is_check_url,
                    order_number: resp.list[i].order_number,
                    is_trusted_only: resp.list[i].is_trusted_only,
                    is_mobile: resp.list[i].is_mobile,
                    is_desktop: resp.list[i].is_desktop,
                    is_locked: resp.list[i].is_locked,
                    trust_zone_code: resp.list[i].trust_zone_code,
                    trust_zone_title: resp.list[i].trust_zone_title,
                    is_custom_trusted_amounts: resp.list[i].is_custom_trusted_amounts,
                    min_deposit_amount_trusted: resp.list[i].min_deposit_amount_trusted,
                    max_deposit_amount_trusted: resp.list[i].max_deposit_amount_trusted,
                    min_dep_amount_to_handle_as_trusted: resp.list[i].min_dep_amount_to_handle_as_trusted,
                    is_trusted_by_custom_deposit_count: resp.list[i].is_trusted_by_custom_deposit_count,
                    min_deposit_count_to_be_trusted: resp.list[i].min_deposit_count_to_be_trusted,
                    is_trusted_by_custom_withdraw_count: resp.list[i].is_trusted_by_custom_withdraw_count,
                    min_withdraw_count_to_be_trusted: resp.list[i].min_withdraw_count_to_be_trusted,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    is_use_min_dep_amount_per_day_limit: resp.list[i].is_use_min_dep_amount_per_day_limit,
                    min_dep_amount_per_day_limit: resp.list[i].min_dep_amount_per_day_limit,
                    is_mark_suspicious_withdraw_on_treshold_dep_amount: resp.list[i].is_mark_suspicious_withdraw_on_treshold_dep_amount,
                    treshold_dep_amount_to_mark_suspicious: resp.list[i].treshold_dep_amount_to_mark_suspicious,
                    is_randomize_per_day_amount_by_percent: resp.list[i].is_randomize_per_day_amount_by_percent,
                    min_dep_amount_limit_randomize_percent: resp.list[i].min_dep_amount_limit_randomize_percent,
                    max_dep_amount_limit_randomize_percent: resp.list[i].max_dep_amount_limit_randomize_percent,
                    randomized_min_dep_amount_per_day_limit: resp.list[i].randomized_min_dep_amount_per_day_limit,
                    date_limit_randomized: moment(resp.list[i].date_limit_randomized_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayProvidersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandPayProvider.exec({
            data: {
                brand_id: data.brand_id,
                app_currency_id: data.app_currency_id,
                provider_identity: data.provider_identity,
                provider_name: data.provider_name,
                provider_system: data.provider_system,
                provider_logo: data.provider_logo,
                time_to_expire: data.time_to_expire,
                min_deposit_amount: data.min_deposit_amount,
                max_deposit_amount: data.max_deposit_amount,
                is_check_url: data.is_check_url,
                is_locked: data.is_locked,
                order_number: data.order_number,
                is_trusted_only: data.is_trusted_only,
                is_mobile: data.is_mobile,
                is_desktop: data.is_desktop,
                trust_zone_code: data.trust_zone_code,
                is_custom_trusted_amounts: data.is_custom_trusted_amounts,
                min_deposit_amount_trusted: data.min_deposit_amount_trusted,
                max_deposit_amount_trusted: data.max_deposit_amount_trusted,
                min_dep_amount_to_handle_as_trusted: data.min_dep_amount_to_handle_as_trusted,
                is_trusted_by_custom_deposit_count: data.is_trusted_by_custom_deposit_count,
                min_deposit_count_to_be_trusted: data.min_deposit_count_to_be_trusted,
                is_trusted_by_custom_withdraw_count: data.is_trusted_by_custom_withdraw_count,
                min_withdraw_count_to_be_trusted: data.min_withdraw_count_to_be_trusted,
                description: data.description,
                is_use_min_dep_amount_per_day_limit: data.is_use_min_dep_amount_per_day_limit,
                min_dep_amount_per_day_limit: data.min_dep_amount_per_day_limit,
                is_mark_suspicious_withdraw_on_treshold_dep_amount: data.is_mark_suspicious_withdraw_on_treshold_dep_amount,
                treshold_dep_amount_to_mark_suspicious: data.treshold_dep_amount_to_mark_suspicious,
                is_randomize_per_day_amount_by_percent: data.is_randomize_per_day_amount_by_percent,
                min_dep_amount_limit_randomize_percent: data.min_dep_amount_limit_randomize_percent,
                max_dep_amount_limit_randomize_percent: data.max_dep_amount_limit_randomize_percent
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                provider_identity: data.provider_identity,
                provider_name: data.provider_name,
                provider_system: data.provider_system,
                provider_logo: data.provider_logo,
                time_to_expire: data.time_to_expire,
                min_deposit_amount: data.min_deposit_amount,
                max_deposit_amount: data.max_deposit_amount,
                is_check_url: data.is_check_url,
                order_number: data.order_number,
                is_locked: data.is_locked,
                is_trusted_only: data.is_trusted_only,
                is_mobile: data.is_mobile,
                is_desktop: data.is_desktop,
                trust_zone_code: data.trust_zone_code,
                trust_zone_title: resp.trust_zone_title,
                is_custom_trusted_amounts: data.is_custom_trusted_amounts,
                min_deposit_amount_trusted: data.min_deposit_amount_trusted,
                max_deposit_amount_trusted: data.max_deposit_amount_trusted,
                min_dep_amount_to_handle_as_trusted: data.min_dep_amount_to_handle_as_trusted,
                is_trusted_by_custom_deposit_count: data.is_trusted_by_custom_deposit_count,
                min_deposit_count_to_be_trusted: data.min_deposit_count_to_be_trusted,
                is_trusted_by_custom_withdraw_count: data.is_trusted_by_custom_withdraw_count,
                min_withdraw_count_to_be_trusted: data.min_withdraw_count_to_be_trusted,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                description: data.description,
                is_use_min_dep_amount_per_day_limit: data.is_use_min_dep_amount_per_day_limit,
                min_dep_amount_per_day_limit: data.min_dep_amount_per_day_limit,
                is_mark_suspicious_withdraw_on_treshold_dep_amount: data.is_mark_suspicious_withdraw_on_treshold_dep_amount,
                treshold_dep_amount_to_mark_suspicious: data.treshold_dep_amount_to_mark_suspicious,
                is_randomize_per_day_amount_by_percent: data.is_randomize_per_day_amount_by_percent,
                min_dep_amount_limit_randomize_percent: data.min_dep_amount_limit_randomize_percent,
                max_dep_amount_limit_randomize_percent: data.max_dep_amount_limit_randomize_percent,
                randomized_min_dep_amount_per_day_limit: resp.randomized_min_dep_amount_per_day_limit,
                date_limit_randomized: moment(resp.date_added_uts_ms).utc(false),
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsPayProvidersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandPayProvider.exec({
                data: {
                    brands_pay_provider_config_id: data.key,
                    provider_identity: data.provider_identity,
                    provider_name: data.provider_name,
                    provider_system: data.provider_system,
                    provider_logo: data.provider_logo,
                    time_to_expire: data.time_to_expire,
                    min_deposit_amount: data.min_deposit_amount,
                    max_deposit_amount: data.max_deposit_amount,
                    is_check_url: data.is_check_url,
                    is_locked: data.is_locked,
                    order_number: data.order_number,
                    is_trusted_only: data.is_trusted_only,
                    is_mobile: data.is_mobile,
                    is_desktop: data.is_desktop,
                    trust_zone_code: data.trust_zone_code,
                    is_custom_trusted_amounts: data.is_custom_trusted_amounts,
                    min_deposit_amount_trusted: data.min_deposit_amount_trusted,
                    max_deposit_amount_trusted: data.max_deposit_amount_trusted,
                    min_dep_amount_to_handle_as_trusted: data.min_dep_amount_to_handle_as_trusted,
                    is_trusted_by_custom_deposit_count: data.is_trusted_by_custom_deposit_count,
                    min_deposit_count_to_be_trusted: data.min_deposit_count_to_be_trusted,
                    is_trusted_by_custom_withdraw_count: data.is_trusted_by_custom_withdraw_count,
                    min_withdraw_count_to_be_trusted: data.min_withdraw_count_to_be_trusted,
                    description: data.description,
                    is_use_min_dep_amount_per_day_limit: data.is_use_min_dep_amount_per_day_limit,
                    min_dep_amount_per_day_limit: data.min_dep_amount_per_day_limit,
                    is_mark_suspicious_withdraw_on_treshold_dep_amount: data.is_mark_suspicious_withdraw_on_treshold_dep_amount,
                    treshold_dep_amount_to_mark_suspicious: data.treshold_dep_amount_to_mark_suspicious,
                    is_randomize_per_day_amount_by_percent: data.is_randomize_per_day_amount_by_percent,
                    min_dep_amount_limit_randomize_percent: data.min_dep_amount_limit_randomize_percent,
                    max_dep_amount_limit_randomize_percent: data.max_dep_amount_limit_randomize_percent
                }
            }, function (resp) {
                _tmp.provider_identity = data.provider_identity;
                _tmp.provider_name = data.provider_name;
                _tmp.provider_system = data.provider_system;
                _tmp.provider_logo = data.provider_logo;
                _tmp.time_to_expire = data.time_to_expire;
                _tmp.min_deposit_amount = data.min_deposit_amount;
                _tmp.max_deposit_amount = data.max_deposit_amount;
                _tmp.is_check_url = data.is_check_url;
                _tmp.is_locked = data.is_locked;
                _tmp.order_number = data.order_number;
                _tmp.is_trusted_only = data.is_trusted_only;
                _tmp.is_mobile = data.is_mobile;
                _tmp.is_desktop = data.is_desktop;
                _tmp.trust_zone_code = data.trust_zone_code;
                _tmp.trust_zone_title = resp.trust_zone_title;
                _tmp.is_custom_trusted_amounts = data.is_custom_trusted_amounts;
                _tmp.min_deposit_amount_trusted = data.min_deposit_amount_trusted;
                _tmp.max_deposit_amount_trusted = data.max_deposit_amount_trusted;
                _tmp.min_dep_amount_to_handle_as_trusted = data.min_dep_amount_to_handle_as_trusted;
                _tmp.is_trusted_by_custom_deposit_count = data.is_trusted_by_custom_deposit_count;
                _tmp.min_deposit_count_to_be_trusted = data.min_deposit_count_to_be_trusted;
                _tmp.is_trusted_by_custom_withdraw_count = data.is_trusted_by_custom_withdraw_count;
                _tmp.min_withdraw_count_to_be_trusted = data.min_withdraw_count_to_be_trusted;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.is_use_min_dep_amount_per_day_limit = data.is_use_min_dep_amount_per_day_limit;
                _tmp.min_dep_amount_per_day_limit = data.min_dep_amount_per_day_limit;
                _tmp.is_mark_suspicious_withdraw_on_treshold_dep_amount = data.is_mark_suspicious_withdraw_on_treshold_dep_amount;
                _tmp.treshold_dep_amount_to_mark_suspicious = data.treshold_dep_amount_to_mark_suspicious;
                _tmp.randomized_min_dep_amount_per_day_limit = resp.randomized_min_dep_amount_per_day_limit,
                    _tmp.date_limit_randomized = moment(resp.date_changed_uts_ms).utc(false),
                    _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayProvidersListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandsPayProvidersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandPayProvider.exec({
                data: {
                    brands_pay_provider_config_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayProvidersListCtl.prototype.DoSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandPayProviderIsLocked.exec({
                data: {
                    brands_pay_provider_config_id: key,
                    is_locked: isLocked
                }
            }, function (resp) {
                _tmp.is_locked = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayProvidersListCtl.prototype.DoSetOrderNumber = function (key, orderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandPayProviderOrderNumber.exec({
                data: {
                    brands_pay_provider_config_id: key,
                    order_number: orderNumber
                }
            }, function (resp) {
                _tmp.order_number = orderNumber;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsPayProvidersListCtl.prototype.getPayProviderLimitsDetails = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DetailsBrandPayProviderLimitGet.exec({
                brand_pay_provider_config_id: key
            }, function (resp) {
                ;
                _this.Update();
                if (onDone) {
                    onDone({
                        dep_amount_done_last_24h: resp.dep_amount_done_last_24h,
                        dep_amount_max_last_24h: resp.dep_amount_max_last_24h,
                        is_dep_amount_max_last_24h: resp.is_dep_amount_max_last_24h
                    });
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandsPayProvidersListCtl;
}(BaseController_1.BaseController));
exports.BrandsPayProvidersListCtl = BrandsPayProvidersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsPayProvidersLictCtl.ts
// module id = 1042
// module chunks = 0